export const filterProps = {
  filterOption: (input?: string, option?: any) => {
    return option.label.toLowerCase().indexOf(input!.toLowerCase()) >= 0
  },
  filterSort: (optionA: any, optionB: any) => {
    return optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
  },
}

export const parseApiErrorResponse = (response) => {
  if (!response?.error) {
    return {}
  }

  const errors = response.error

  return Object.keys(errors).reduce((accumulator, current) => {
    const [{ validator }] = errors[current]
    accumulator[`${current}`] = apiErrorKeys[validator]

    return accumulator
  }, {})
}

interface YupError {
  propertyPath: string
  message: string
}

interface ValidationErrors {
  errors: {
    body: YupError[]
  }
}

export const parseApiValidationErrors = (validationErrors: ValidationErrors) => {
  if (!validationErrors?.errors) {
    return {}
  }

  const errors = validationErrors.errors.body

  return errors.reduce((apiErrors: { [key: string]: string }, currentError: YupError) => {
    apiErrors[currentError.propertyPath] = currentError.message

    return apiErrors
  }, {})
}

const apiErrorKeys = {
  'invalid-number': 'must be a valid number',
  'not-unique': 'must be unique',
  len: 'check the current value length',
  required: 'required field',
  'invalid-code': "it is only allowed the following special characters: &'().-",
}
